/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Fade from 'react-reveal/Fade';

import Button from 'elements/Button';

export default function Discuss() {
  return (
    <Fade bottom>
      <section className="flex container mx-auto justify-center px-4 py-8">
        <div className="relative flex flex-col w-full sm:w-11/12 xl:w-10/12 rounded-2xl bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white py-14 sm:px-12 sm:py-20 xl:px-16 shadow-2xl discuss overflow-hidden">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" />

          {/* Decorative icons */}
          <div className="absolute top-8 right-8 opacity-10">
            <svg className="w-24 h-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div className="absolute bottom-8 left-8 opacity-10">
            <svg className="w-20 h-20 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>

          <div className="relative flex flex-col sm:flex-row mb-6 sm:mb-9 p-5 sm:p-0 sm:items-center z-10">
            <div className="flex-1">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-tight font-bold">
                  Ready to Transform Your Business?
                </h1>
              </div>
              <p className="font-light text-lg sm:text-xl lg:text-2xl mb-6 text-white/90 ml-16">
                Don&apos;t hesitate to contact us, we&apos;d love to hear your story and help
                bring your vision to life.
              </p>
            </div>
            <Button href="/discuss-project" type="link" className="flex bg-white text-theme-purple text-lg lg:text-xl font-semibold tracking-wide items-center justify-center w-full sm:w-auto px-8 py-4 lg:py-5 border-2 border-white shadow-xl rounded-xl mt-6 sm:mt-0 sm:ml-8 transform transition-all duration-300 hover:scale-105 hover:shadow-2xl z-10">
              Contact Us
              <svg className="ml-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Button>
          </div>
        </div>
      </section>
    </Fade>
  );
}
